<template>
 <div class="contents-part">
   <div class="column-part">
      <div class="column-title">旅游时间是否有特殊要求：</div>
      <div class="label-part">
        <span class="single-label"
        v-for="ele in STR"
              :key="ele.id"
        >{{ ele.name }}</span>
      </div>
   </div>
   <div class="column-part">
     <div class="column-title">旅途中比较注重那些方面：</div>
     <div class="label-part">
       <span class="single-label"
       v-for="item in PAA"
             :key="item.id"
       >{{ item.name }}</span>
     </div>
   </div>
   <div class="column-part">
     <div class="column-title">理想中的旅游天数：</div>
     <div class="label-part" style="margin-left:88px">
       <span class="single-label"
       v-for="item in DT"
             :key="item.id"
       >{{ item.name }}</span>
     </div>
   </div>
   <div class="column-part" >
     <div class="column-title">出游过程中更想体验哪方面：</div>
     <div class="label-part" style="margin-left:26px;position:relative"
     >
       <span class="single-label"
       v-for="item in EP"
             :key="item.id"
       >{{ item.name }}</span>
       <div class="compile-btn" @click="compileInfo">
         <i class="iconfont icon-tianxie" style="font-size: 25px"></i>
         <span>编辑</span>
       </div>
     </div>

   </div>
 </div>
</template>

<script>
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";

export default {
  name: "serAdvisory",
  data() {
    return {
      id:'',
      STR:[],
      PAA:[],
      DT:[],
      EP:[]
    }
  },
  created() {
      this.id = this.$route.params.id;
      this.lookTravelInfo()
  },
  methods:{
     //查看旅游咨询相关信息
     lookTravelInfo(){
       let params = new URLSearchParams()
       params.set("customerId",this.id)
       axios.post(`${ipAddress.qi}/admin/a1/serve-survey/getByCid`,params).then(
         value =>{
           const content = value.content
           this.STR = content.time.filter(el =>el.choose)
           this.PAA = content.journey.filter(el =>el.choose)
           this.DT = content.days.filter(el =>el.choose)
           this.EP = content.experience.filter(el =>el.choose)
         }
       )
     },
     //点击编辑信息
     compileInfo(){
       this.$router.replace(`/index/customers/serviceAdvisoryCompile/${this.id}`)
     },
  },
  watch:{
    $route:{
      handler(from,to){
        const fromId = from.params.id
        const  toId = to.params.id
        if(!(fromId == toId)){
          this.id = toId;
          this.lookTravelInfo()
        }
      }
    }
  }
}
</script>

<style scoped>
.contents-part{
  width: auto;
  height: auto;
  margin-left: 7rem;
}
.column-part{
  width:100%;
  height: auto;
  display: flex;
}

.column-title{
  width: auto;
  height: auto;
  font-size: 0.9rem;
  letter-spacing:1px;
  color:black;
  margin-top:0.5rem ;
  white-space: nowrap;
}
.label-part{
  width:auto;
  word-break: break-all;
  word-wrap: break-word;
  margin-left: 42px;
  display: flex;
  flex-wrap: wrap;
}
.single-label{
  width: auto;
  height: auto;
  background-color: #E4F2FF;
  border:1px solid #3495EF;
  padding: 0.5rem 1.5rem;
  border-radius:5px;
  font-size:0.95rem;
  letter-spacing:2px;
  color: #3495EF;
  margin-left: 50px;
  margin-bottom: 15px;
}
.compile-btn{
  position:absolute;
  bottom:0;
  right:0;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  margin-right:-143px;
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:center;
  font-size: 0.85rem;
  letter-spacing: 2px;
  color: #387EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/serAdvisory.vue